import { combineReducers } from "redux";

// Reducers
import formReducer from "./formReducer";
import notificationReducer from "./notificationReducer";
import userReducer from "./userReducer";

export default combineReducers({
  form: formReducer,
  notification: notificationReducer,
  user: userReducer,
});
